import { ErrorBoundary, BaseLayout, NotFound } from '@/components';
import NetworkPage from '@/pages/network';
import WalletsPage from '@/pages/network/wallets';
import WalletPage from '@/pages/network/wallets/walletAddress';
import WalletActivityPage from '@/pages/network/wallets/walletAddress/activity';
import MarketsPage from '@/pages/network/markets';
import MarketPage from '@/pages/network/markets/marketAddress';
import LiquidationsPage from '@/pages/network/liquidations';
import LiquidatorsPage from '@/pages/network/liquidations/liquidators';
import LiquidatorPage from '@/pages/network/liquidations/liquidators/liquidator';
import MarketActivityPage from '@/pages/network/markets/marketAddress/activity';
import MarketWalletsPage from '@/pages/network/markets/marketAddress/wallets';
import MarketParametersPage from '@/pages/network/parameters';
import { createBrowserRouter, Navigate } from 'react-router';
import ValidateNetwork from './ValidateNetwork';
import MarketWalletPage from '@/pages/network/markets/marketAddress/wallets/walletAddress';
import WalletMarketActivityPage from '@/pages/network/markets/marketAddress/wallets/walletAddress/activity';
import OverallActivityPage from '@/pages/network/activity';
import OverallEventsPage from '@/pages/network/activity/events';
import TreasuryPage from '@/pages/network/treasury';
import MarketDebtPage from '@/pages/network/markets/marketAddress/debt';
import MarketCollateralPage from '@/pages/network/markets/marketAddress/collateral';
import BadDebtPage from '@/pages/network/badDebt';
import RiskPage from '@/pages/network/risk';

const router = createBrowserRouter([
  {
    errorElement: <ErrorBoundary />,
    children: [
      {
        element: <BaseLayout />,
        children: [
          {
            path: '/',
            element: <Navigate to="/ethereum/" />
          }
        ]
      },
      {
        path: '/v1/*',
        element: <Navigate to="/ethereum/" replace />
      },
      {
        path: '/:network',
        element: <ValidateNetwork />,
        children: [
          {
            index: true,
            element: <NetworkPage />
          },
          {
            path: 'activity',
            element: <OverallActivityPage />
          },
          {
            path: 'activity/events',
            element: <OverallEventsPage />
          },
          {
            path: 'wallets',
            element: <WalletsPage />
          },
          {
            path: 'bad-debt',
            element: <BadDebtPage />
          },
          {
            path: 'wallets/:walletAddress',
            element: <WalletPage />
          },
          {
            path: 'wallets/:walletAddress/activity',
            element: <WalletActivityPage />
          },
          {
            path: 'markets',
            element: <MarketsPage />
          },
          {
            path: 'liquidations',
            element: <LiquidationsPage />
          },
          {
            path: 'liquidations/liquidators',
            element: <LiquidatorsPage />
          },
          {
            path: 'liquidations/liquidators/:liquidatorAddress',
            element: <LiquidatorPage />
          },
          {
            path: 'markets/:marketAddress',
            element: <MarketPage />
          },
          {
            path: 'markets/:marketAddress/debt',
            element: <MarketDebtPage />
          },
          {
            path: 'markets/:marketAddress/collateral',
            element: <MarketCollateralPage />
          },
          {
            path: 'markets/:marketAddress/activity',
            element: <MarketActivityPage />
          },
          {
            path: 'markets/:marketAddress/wallets',
            element: <MarketWalletsPage />
          },
          {
            path: 'markets/:marketAddress/wallets/:walletAddress',
            element: <MarketWalletPage />
          },
          {
            path: 'parameters',
            element: <MarketParametersPage />
          },
          {
            path: 'markets/:marketAddress/wallets/:walletAddress/activity',
            element: <WalletMarketActivityPage />
          },
          {
            path: 'treasury',
            element: <TreasuryPage />
          },
          {
            path: 'risk',
            element: <RiskPage />
          },
          {
            path: '*',
            element: <NotFound />
          }
        ]
      }
    ]
  }
]);

export default router;
